import { gql } from '@apollo/client';
import { LONG_TRANSACTION_FIELDS_FRAGMENT } from './longTransactionFieldsFragment.gql';

const LONG_TRANSACTION_CREATE_SUBSCRIPTION = gql`
  ${LONG_TRANSACTION_FIELDS_FRAGMENT}
  subscription onCreateLongTransaction($input: LongTransactionSubscriptionFilterInput) {
    onCreateLongTransaction(input: $input) {
      ...LongTransactionFields
    }
  }
`;

const LONG_TRANSACTION_UPDATE_SUBSCRIPTION = gql`
  ${LONG_TRANSACTION_FIELDS_FRAGMENT}
  subscription onUpdateLongTransaction($input: LongTransactionSubscriptionFilterInput) {
    onUpdateLongTransaction(input: $input) {
      ...LongTransactionFields
    }
  }
`;

const LONG_TRANSACTION_ENTER_SUBSCRIPTION = gql`
  ${LONG_TRANSACTION_FIELDS_FRAGMENT}
  subscription onEnterLongTransaction($input: LongTransactionSubscriptionFilterInput) {
    onEnterLongTransaction(input: $input) {
      ...LongTransactionFields
    }
  }
`;

const LONG_TRANSACTION_LEAVE_SUBSCRIPTION = gql`
  ${LONG_TRANSACTION_FIELDS_FRAGMENT}
  subscription onLeaveLongTransaction($input: LongTransactionSubscriptionFilterInput) {
    onLeaveLongTransaction(input: $input) {
      ...LongTransactionFields
    }
  }
`;

export {
  LONG_TRANSACTION_CREATE_SUBSCRIPTION,
  LONG_TRANSACTION_UPDATE_SUBSCRIPTION,
  LONG_TRANSACTION_ENTER_SUBSCRIPTION,
  LONG_TRANSACTION_LEAVE_SUBSCRIPTION,
};
